import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as images from '../../assets/images';
import { H3 } from '../Text/Text';

import styles from './about.module.scss';

const ABOUT_SECTIONS = [
    {
        title: 'Advertising Agency',
        description: 'No hassle, no stress. Create your advertising project any time, quickly and efficiently. Monitor the process from beginning to end.',
        fullDescription: 'This is a stress-free zone. Take control of your creative workflow with real time tracking, instant feedback, and online preview of ads before broadcasting. To make things simple, we\'ve created an ad delivery platform that connects you with post production companies and broadcasters, and improves your communication and workflow.',
    },
    {
        title: 'Post Company',
        description: 'Upload your creative videos with a fast and reliable system. Don’t worry about the quality assurance, that’s on us.',
        fullDescription: 'No more time-consuming quality checks, no more worries. JumboMedia is here to save you time with quick and reliable delivery of your ads, and automated quality checks. All this while keeping you updated with notifications and full transparency during the delivery process.',
    },
    {
        title: 'Broadcaster',
        description: 'Sit back and relax as we deliver high quality ads to you. We will take care of quality checks and keep you updated the whole time.',
        fullDescription: 'One efficient ad delivery platform where everything takes place. Receive high quality ads through a reliable system which automatically transfers the files to your servers. Keep track of every delivery from beginning to end with automated notifications and full transparency along the way.',
    },
];

const About = () => {
    const [hoveredItem, setHoveredItem] = useState(-1);
    const handleMouseEnter = (index: number) => {
        setHoveredItem(index);
        // const fullDescription = document.querySelector(`#full-description-${index}`);
        // const description: HTMLDivElement = document.querySelector(`#description-${index}[data-index="${index}"]`);

        // if (fullDescription && description) {
        //     fullDescription.classList.add(styles.fullDescriptionHover);
        //     description.style.display = 'none';
        // }
    };

    const handMouseLeave = (index: number) => {
        setHoveredItem(-1);
        // const fullDescription = document.querySelector(`.${styles.fullDescription}[data-index="${index}"]`);
        // const description: HTMLDivElement = document.querySelector(`#description-${index}[data-index="${index}"]`);

        // if (fullDescription && description) {
        //     fullDescription.classList.remove(styles.fullDescriptionHover);
        //     description.style.display = 'block';
        // }
    };

    return (
        <section className={styles.wrapper} id='about'>
            <h2>JumboMedia</h2>
            <H3>Where Ad Delivery and Peace of Mind Meet</H3>
            <p>
                JumboMedia was created to streamline the management and delivery of video ads to broadcasters. We connect advertising agencies, post production companies and broadcasters into one whole eco-system.
            </p>
            <ul className={styles.sectionList} >
                {ABOUT_SECTIONS.map((section, index) => (
                    <li
                        key={index}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={() => handMouseLeave(index)}
                        style={{
                            backgroundImage: index === hoveredItem ?
                                `url('${images[`aboutHover${index + 1}`]}')` :
                                undefined,
                        }}
                    >
                        {index === hoveredItem ? (
                            <div className={styles.hoveredItem}>
                                <div className={styles.titleWrapper}>
                                    <img src={images[`aboutIcon${index + 1}`]} alt={section.title} />
                                    <h3>{section.title}</h3>
                                </div>
                                <p className={styles.fullDescription}>{section.fullDescription}</p>
                            </div>
                        ) : (
                            <div>
                                <img
                                    src={images[`about${index + 1}`]}
                                    alt={section.title}
                                    className={styles.photo}
                                />
                                <div className={styles.info}>
                                    <div className={styles.titleWrapper}>
                                        <img src={images[`aboutIcon${index + 1}`]} alt={section.title} />
                                        <h3>{section.title}</h3>
                                    </div>
                                    <p>{section.description}</p>
                                </div>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default About;